<template>
  <div>
    <div id="GiftOption">
      <div class="wrapper">
        <b-col id="title">
          <h1>Member Gift Options</h1>
          <div class="line"></div>
        </b-col>
        <p class="smallPrint">
          **Members will be able to choose personalized Season Member Gift prior
          to the start of the 2024 season.
        </p>
        <div class="tableHeaders">
          <div class="tableHeader" style="flex-basis: 30%"><h2>Gift</h2></div>
          <div class="tableHeader" style="flex-basis: 20%">
            <h2>Quantity</h2>
          </div>
          <div class="nestedTableHeader" style="flex-basis: 50%">
            <h2 style="flex-basis: 100%">Season Member Spend</h2>
            <h2>$12,000+</h2>
            <h2>$8,000-$11,999</h2>
            <h2>$4,000-$7,999</h2>
            <h2>$1,000-$3,999</h2>
            <h2>Tier 1<br />(Choose 2*)</h2>
            <h2>Tier 2<br />(Choose 1)</h2>
            <h2>Tier 3<br />(Choose 1)</h2>
            <h2>Tier 4<br />(Choose 1)</h2>
          </div>
        </div>
        <table id="benefitTable" class="table table-striped">
          <thead class="table-borderless">
            <tr class="text-center align-middle">
              <td style="width: 30%">1. Batting Practice</td>
              <td style="width: 20%">1 per seat</td>
              <td style="width: 12.5%">X</td>
              <td style="width: 12.5%">X</td>
              <td style="width: 12.5%">-</td>
              <td style="width: 12.5%">-</td>
            </tr>
          </thead>
          <tbody class="text-center">
            <tr>
              <td>2. The Baldwin Group Club/Chalk Box/Fieldside Box Tickets (1game)</td>
              <td>1 per seat</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>-</td>
            </tr>
            <tr>
              <td>3. Rays Jersey</td>
              <td>1 per seat</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>-</td>
            </tr>
            <tr>
              <td>4. Rays Hooded Sweater</td>
              <td>1 per seat</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>-</td>
            </tr>
            <tr>
              <td>
                5. Rowdies Match Experience
              </td>
              <td>1 per seat</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
            </tr>
            <tr>
              <td>6. Donation to the Rays Baseball Foundation</td>
              <td>1 per account</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
            </tr>
            <tr>
              <td>7. Mascot Brunch</td>
              <td>1 per seat</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
            </tr>
            <tr>
              <td>8. Rays Toiletry Bag</td>
              <td>1 per seat</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
              <td>X</td>
            </tr>
          </tbody>
        </table>
        <b-row>
          <b-col>
            <p class="smallPrint">
              *Tier 1 – Choose 2 gifts, one from gifts 1-4 and one from gifts
              5-8. Ex: The Baldwin Group Club Tickets and Donation to the Rays Baseball
              Foundation.
            </p>
          </b-col>
        </b-row>
        <div class="parkingBreak">
          <h3>
            Complimentary Parking for $20,000 Flexible Season Members and for
            the following Traditional Season Member Seating Categories
          </h3>
        </div>
        <div style="overflow-x: auto">
          <table id="parkingTable" class="table table-striped">
            <thead class="table-borderless">
              <tr class="text-center align-middle">
                <th scope="col">Lot #</th>
                <th scope="col" style="width: 16%">
                  DEX Imaging Home Plate Club
                </th>
                <th scope="col">The Baldwin Group Club Full Season</th>
                <th scope="col">Fieldside Box Full Season</th>
                <th scope="col">Chalk Box Full Season</th>
                <th scope="col">The Baldwin Group Club Half Season</th>
                <th scope="col">Chalk Box Half Season</th>
              </tr>
            </thead>
            <tbody class="text-center">
              <tr>
                <td>Lot 1</td>
                <td>2 Seats Needed</td>
                <td>4 Seats Needed</td>
                <td>4 Seats Needed</td>
                <td>4 Seats Needed</td>
                <td>N/A</td>
                <td>N/A</td>
              </tr>
              <tr>
                <td>Lot 2/6</td>
                <td>N/A</td>
                <td>2 Seats Needed</td>
                <td>2 Seats Needed</td>
                <td>2 Seats Needed</td>
                <td>4 Seats Needed</td>
                <td>4 Seats Needed</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- <b-row>
        <b-col>
          <p class="mediumPrint">
            Season Members will be notified at a later date with more details
            for each gift and regarding gift selection.
          </p>
        </b-col>
      </b-row> -->
      </div>
    </div>
    <Banner bannerDivider="fifth" />
  </div>
</template>

<script>
import Banner from "@/components/sections/Banner/Banner";

export default {
  name: "GiftOption",
  components: {
    Banner,
  },
};
</script>

<style lang="scss" scoped>
#GiftOption {
  padding: 150px 0 100px;
  background-image: url("~@/assets/images/welcome/bgImage_gray.jpg");
  background-size: cover;
  @media only screen and (max-width: $md) {
    padding-block: 70px;
  }
  .wrapper {
    max-width: 1024px;
    margin: 0 auto;
    padding-inline: 10px;
  }

  #title {
    padding: 0;
    .line {
      background-color: $yellow;
      width: 416px;
      height: 5px;
      margin: 15px 0 1em;
      @media only screen and (max-width: "1190px") {
        width: 300px;
      }
    }
    h1 {
      font-family: "Antique Olive";
      font-style: normal;
      font-weight: 700;
      font-size: 35px;
      line-height: 1;
      text-transform: uppercase;
      color: #00285e;
      @media only screen and (max-width: "1190px") {
        font-size: 25px;
      }
    }
  }
  .table-striped > tbody > tr:nth-child(2n + 1) > td,
  .table-striped > tbody > tr:nth-child(2n + 1) > th {
    background-color: #cccccc;
  }

  .tableHeaders {
    text-align: center;
    color: #fff;
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
    h2 {
      font-family: "Futura";
      font-size: 16px;
    }
    div {
      margin: 0px 1px;
      background-color: $dark-blue;
    }
    .tableHeader {
      position: relative;
      h2 {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, -50%);
        @media only screen and (max-width: $md) {
          zoom: 0.8;
        }
        @media only screen and (max-width: $sm) {
          zoom: 0.6;
        }
      }
    }
    .nestedTableHeader {
      display: flex;
      flex-wrap: wrap;
      @media only screen and (max-width: $md) {
        zoom: 0.8;
      }
      @media only screen and (max-width: $sm) {
        zoom: 0.6;
      }
      @media only screen and (max-width: "400px") {
        zoom: 0.5;
      }
      h2 {
        border: 1px solid #fff;
        flex-basis: 25%;
        padding: 5px;
        @media only screen and (max-width: "1190px") {
          flex-basis: 25%;
          font-size: 10px;
          padding: 3px 0px;
        }
      }
    }
  }
  #benefitTable {
    font-family: "Futura";
    .checkmark {
      color: #3a8fc6;
    }
    @media only screen and (max-width: $md) {
      zoom: 0.8;
    }
    @media only screen and (max-width: $sm) {
      zoom: 0.6;
    }
    td:first-child {
      text-align: left;
      padding-left: 40px;
    }
    @media only screen and (max-width: "1190px") {
      td:first-child {
        padding-left: 15px;
      }
    }
    @media only screen and (max-width: $sm) {
      td:first-child {
        padding-left: 3px;
      }
      td {
        text-align: center;
        padding-left: 0;
      }
    }
  }
  .smallPrint {
    font-family: "Futura";
    font-size: 14px;
    margin: 10px 0;
  }
  .mediumPrint {
    font-family: "Futura";
    font-size: 16px;
    margin: 10px 0 100px;
  }
  .parkingBreak {
    background-color: $dark-blue;
    text-align: center;
    margin: 50px auto 0;
    padding: 11px;
    @media only screen and (max-width: $md) {
      zoom: 0.8;
    }

    h3 {
      font-family: "Futura";
      font-size: 16px;
      color: #fff;
      margin-top: 4px;
    }
  }
  #parkingTable {
    margin-bottom: 0;
    @media only screen and (max-width: $md) {
      zoom: 0.8;
    }
    @media only screen and (max-width: $sm) {
      zoom: 0.6;
    }
    th {
      width: 14%;
      font-family: "Futura";
      font-size: 16px;
      @media only screen and (max-width: "1190px") {
        font-size: 13px;
      }
    }
    tbody {
      font-family: "Futura";
    }
  }
}
</style>
